<template>
<div   :style="{
    fontSize: $vuetify.breakpoint.xs ? '12px' : '16px'
  }">
   <!-- SE QUITO la propiedad app PARA QUITAR EL MARGEN , Y SE AGREGO FIXED PARA DEJAR FIJO, Y SE AGREGO EL MARGEN EN HomeTiendaAll.vue -->
<template>
  <CerrarSesionDialog ref="componenteHijo"></CerrarSesionDialog>
<OpenLinksTecDialog ref="componenteHijoOpenLinksTec"></OpenLinksTecDialog>
  <v-app-bar

      fixed
      dark
      height="200"
      
      >
      <template v-slot:img="{ props }" >
        <v-img
          v-bind="props"
          gradient=""
          class="hidden-sm-and-down"
        ></v-img>
      </template>
        <div v-if="!$vuetify.breakpoint.smAndDown" class="d-flex align-center" style="cursor: pointer;" @click="abrirInstagram">
          <v-img
            :src="require('@/assets/img/use/logoteczoav1.png')"
            width="50"
            height="50"
            contain
            class="mr-2"
          ></v-img>
          <div>
            <div class="font-weight-bold" style="font-size: 16px;">{{ DataHome.descripcion }}1</div>
            <div style="font-size: 11px; opacity: 0.8;">
              <v-icon x-small color="white" class="mr-1">mdi-instagram</v-icon>Instagram
            </div>
          </div>
        </div>
        <v-spacer></v-spacer>
 <template v-slot:extension>
 <v-row no-gutters>
   <v-col cols="12" class="hidden-sm-and-down">
 <v-tabs
          align-with-title
          background-color="transparent"
        >

       <v-tab class="mr-3 google-font hidden-sm-and-down"
        style="text-transform: capitalize;pading" 
        @click="openStore()"
        >
        HOME
        </v-tab> 
 <v-tab
        v-for="(link, i) in linksStore"
        :key="i"
        :to="link.to"
        class="mr-3 google-font hidden-sm-and-down"
        
        @click="onClick($event, link)"
        data-cy="menu"
      >
        {{ link.text }}
        </v-tab>
       <v-tab class="mr-3 google-font hidden-sm-and-down"
        @click="openLinksTec()"
         >
        Links Tec
        </v-tab>
  </v-tabs>
  </v-col>
  <v-col cols="2" class="hidden-sm-and-down d-flex justify-end align-center">
    <div style="position: fixed; top: 12px; right: 20px; z-index: 1000; display: flex; align-items: center; gap: 8px;">
      <!-- Blog -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="irAlBlog">
            <v-icon color="white">mdi-post-outline</v-icon>
          </v-btn>
        </template>
        <span>Blog TecZoa — tecnología y más</span>
      </v-tooltip>

      <!-- Carrito -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="irAlCarrito">
            <v-badge :content="cantidadCarrito" :value="cantidadCarrito > 0" color="red" overlap>
              <v-icon color="white">mdi-cart</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Ir al Carrito de Compras</span>
      </v-tooltip>

      <!-- Avatar usuario -->
      <AvatarUsuario />
    </div>
  </v-col>
   </v-row>
   <v-row v-if="esRutaTienda" no-gutters   class="mt-0 pb-16 mb-15">
  <v-col cols="10" class="pb-0">
     <div v-if="$vuetify.breakpoint.smAndDown" class="d-flex align-center justify-center mt-2" style="cursor: pointer;" @click="abrirInstagram">
       <v-img
         :src="require('@/assets/img/use/logoteczoav1.png')"
         width="40"
         height="40"
         contain
         class="mr-2"
         style="flex: none;"
       ></v-img>
       <div>
         <div class="google-font font-weight-bold" style="font-size: 130%;">{{ DataHome.descripcion }}</div>
         <div class="text-center" style="font-size: 11px; color: #666;">
           <v-icon x-small class="mr-1">mdi-instagram</v-icon>Instagram
         </div>
       </div>
     </div>
 
    <div class="font-weight-bold mb-1 ml-1">Productos y Servicios</div>
   <div 
   class="divider mb-2"></div>
  </v-col>
 <v-col cols="10" sm="10" md="10" lg="10" class="mt-0 mb-0">
   <v-select
          v-if="$vuetify.breakpoint.xs"
          :value="vendedorSeleccionadoLocal"
          @change="onChange"
          :items="vendedores"
          item-text="nombre"
          item-value="identificador"
          label="Vendedor"
          dense
          outlined
          hide-details
        />
   <v-radio-group
          v-else
          :value="vendedorSeleccionadoLocal"
   @change="onChange"
         row
         dense
       >
         <v-radio
           v-for="(ven, i) in vendedores"
           :key="i"
           :label="ven.nombre"
           :value="ven.identificador"
         />
       </v-radio-group>
     </v-col>

       <!-- Título + línea -->
  <v-col cols="10" class="pb-0">
    <div class="font-weight-bold mb-1 ml-1">Categorias</div>
    <v-divider class="mb-2"></v-divider>
  </v-col>

 <v-col cols="10" sm="10" md="10" lg="10" class="mt-0 mb-0">
   <v-select
          v-if="$vuetify.breakpoint.xs"
          v-model="categoriaLocal"
          @change="$emit('update-categoria', categoriaLocal)"
          :items="categorias"
          item-text="descripcion"
          item-value="descripcion"
          label="Categoría"
          dense
          outlined
          hide-details
        />
       <v-radio-group
          v-else
          v-model="categoriaLocal"
   @change="$emit('update-categoria', categoriaLocal)"
         row
         dense
       >
         <v-radio
           v-for="(cat, i) in categorias"
           :key="i"
           :label="cat.descripcion"
           :value="cat.descripcion"
         />
       </v-radio-group>
</v-col>

    <v-col cols="10" class="pb-16">
<v-text-field
        :value="buscador"
        @input="updateBuscador"
        placeholder="Ejemplo: Tablero de Ajedrez, Arduino, Crema, Loción"
        outlined
        dense
        hide-details
      >
        <template v-slot:label>
          <v-icon >mdi-magnify</v-icon>
          Busqueda por descripción de productos
        </template>
</v-text-field>
 </v-col>
</v-row>
<v-row no-gutters  class="justify-end">
<!-- Otros iconos 
    <v-col cols="2" class="hidden-sm-and-down">
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-col>
-->
<v-app-bar-nav-icon class="hidden-md-and-up"
      @click="toggleDrawer"></v-app-bar-nav-icon>
    </v-row>
<template>
  </template>
</template>
 </v-app-bar>
</template>
</div>
  </template>
<script>


import CoreView from '@/components/common/View'
import ChapterDetails from '@/assets/data/chapterDetails.json'
import DataHome from '@/assets/data/use/dataHome.json'

import categoriaService from "@/services/tienda/categoriaService.js";

import vendedorService from "@/services/tienda/vendedorService.js";

import router from "@/router/index";


import loginService from "@/services/loginService.js";


import CerrarSesionDialog from "@/components/usuario/CerrarSesionDialog.vue"


import OpenLinksTecDialog from "@/components/tienda/menu/OpenLinksTecDialog.vue"

import AvatarUsuario from "@/components/common/navegacion/AvatarUsuario.vue"


  import { 
    mapGetters,
    mapMutations
  } from 'vuex'
  export default {
    name:'Menu',
    props: {
    buscador: {
      type: String,
      default: ""
    },
    categoriaSeleccionada: {
    type: String,
    default: "todos"
  }
  ,
    vendedorSeleccionado: {
    type: [String, Number],
    default: 'all'
  }
  },
   data() {
      return {

        vendedorSeleccionadoLocal:'all',
        categoriaLocal: this.categoriaSeleccionada,

principal: {

      id: '',
      nombre: '',
      apellido: '',
      descripcion: '',
      linkPhoto: '',
      color: '',
      observacion: '',
      linkVideo: '',
    },
        vendedores:[],
        vendedor:'1',
       // identificadorConsulta:'magzoa',
        ChapterDetails:ChapterDetails,
        DataHome:DataHome,
            showBuscador: true,

              //   categoriaSeleccionada: "todos",
      categorias: [],
      }
    },
    components:{

        CoreView,
        CerrarSesionDialog,
        OpenLinksTecDialog,
        AvatarUsuario,

    },
    computed: {
      ...mapGetters(['linksStore', 'cantidadCarrito']),
      esRutaTienda() {
        return this.$route.name === 'homeTiendaAll';
      }
    },
  async  mounted(){

       await   this.listarVendedores();//cargar datos de vendedore

      /*   const id = this.$route.params.identificador;

    let valor = 0;

    switch (id) {
      case 'all':
        valor = 0;
        break;

      default:
        valor = id;
        break;
    }*/


const identificadorRuta = this.$route.params.identificador;

// Buscar si existe en la lista
const vendedorEncontrado = this.vendedores.find(
  v => v.identificador === identificadorRuta
);

let valor = 'all';

if (identificadorRuta === 'all') {
  valor = 'all';
} 
else if (vendedorEncontrado) {
  // ✅ Existe en la lista
  valor = identificadorRuta;
} 
else {
  // ❌ No existe → redirigir a all
  this.$router.replace({ name: 'homeTiendaAll', params: { identificador: 'all' } });
  valor = 'all';
}



/*const identificadorRuta = this.$route.params.identificador;

const vendedorValido =
  identificadorRuta === 'all' ||
  this.vendedores.some(v => v.identificador === identificadorRuta);

if (!vendedorValido) {
  this.$router.replace({ name: 'homeTiendaAll', params: { identificador: 'all' } });
}

const valor = identificadorRuta === 'all' ? 0 : identificadorRuta;
*/

    this.$emit('update-vendedor', valor);//se emite para actualizar la primera vez tambien el vendedor en la pantalla de productos

  this.vendedorSeleccionadoLocal=valor;



        this.listarCategoriasPublico(valor);

    },


    methods: {


      openLinksTec()
      {

         this.$refs.componenteHijoOpenLinksTec.openDialog();

      },

      irAlCarrito() {
        this.$router.push('/store-carrito');
      },

      irAlBlog() {
        if (this.$route.path !== '/blog') {
          this.$router.push('/blog');
        }
      },

      abrirInstagram() {
        const instagram = this.DataHome.socialLinks.find(s => s.name === 'Instagram');
        if (instagram) {
          window.open(instagram.link, '_blank');
        }
      },



     validarRuta(){




        
      },





     onChange(val) {
      this.$emit('update-vendedor', val);

     // this.vendedorSeleccionado=val;

     this.vendedorSeleccionadoLocal=val;


     this.listarCategoriasPublico(val);


    },

      async listarVendedores() {
  try {
    const res = await vendedorService.listarVendedores();
    this.vendedores = res.data.data;

    // Validar después de cargar
    //this.validarRuta();

  } catch (error) {
    console.error(error);
  } finally {
    this.loading = false;
  }
},

     listarCategoriasPublico(vendedor) {
      //this.loading = true;

      console.log("Cambie de vendedor");
      console.log(vendedor);

      categoriaService
        .listarCategoriasPorVendedor(vendedor)
        .then((resposta) => {
          console.log(resposta.data.data);
          this.categorias = resposta.data.data;
        }).finally(() => {
        //  this.loading = false;
        });

    },

       updateBuscador(value) {
    this.$emit('update-buscador', value);
  },
      ...mapMutations(['toggleDrawer']),
      onClick (e, item) {
        e.stopPropagation()
        if (item.to || !item.href) return
        this.$vuetify.goTo(item.href)
      },
  openStore(){



     
    //this.categoriaLocal = this.categorias[0].descripcion;

    //  this.$emit('update-categoria', 'todos');

    if (this.$route.path !== '/store/all') {
        this.$router.push('/store/all');
      }



  },

  openCerrarSesionDialog() {
    this.$refs.componenteHijo.openDialog(); // Llama al método en el componente hijo
    },
    openLinksTecDialog() {
    this.$refs.componenteHijoOpenLinksTec.openDialog(); // Llama al método en el componente hijo
    },


    }

    ,

  watch: {

     vendedorSeleccionado(newVal) {
      this.vendedorSeleccionadoLocal=newVal;
    this.listarCategoriasPublico(newVal);
  },


  '$route.params.identificador': {
    immediate: true,
    handler(newVal) {
      let valor = 0;

      if (newVal === 'all') {
        valor = 0;
      }
      
      if(newVal === 'teczoa') {
        valor = 1;
      }

       if(newVal === 'lizmar') {
        valor = 2;
      }

      // 🔥 Esto marca el radio correcto
      this.vendedorSeleccionadoLocal = valor;
    }
  }

   /*vendedorSeleccionadoLocal(newVal) {
     this.$emit('update-vendedor', newVal)

  }*/




  }
  } 
</script >

<style scoped>
.divider {
   height: 2px;
   background-color: #ccc;
}



</style>

